import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import GroupByDropdownQuery from './__generated__/GroupByDropdownQuery.graphql';

export const groupByDropdownEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-issue-table-group-by-dropdown" */ './index'),
	),
	getPreloadProps: ({
		nodeId,
		selectedFieldId,
		issueSearchInput,
	}: {
		nodeId: string;
		selectedFieldId?: string | null;
		issueSearchInput?: { jql?: string; filterId?: string };
	}) => ({
		queries: {
			groupByDropdownQuery: {
				parameters: GroupByDropdownQuery,
				variables: {
					nodeId,
					issueSearchInput,
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
		extraProps: {
			selectedFieldId,
		},
	}),
});
